import { useTranslation } from '@dukanti/shared';
import type { AdminOrderReviewFilter, OrderStatus } from '@dukanti/shared';
import { ShoppingCart } from 'lucide-react';

export interface OrdersEmptyProps {
  readonly filter: OrderStatus | null;
  readonly reviewFilter?: AdminOrderReviewFilter | null;
}

export function OrdersEmpty({ filter, reviewFilter = null }: OrdersEmptyProps): React.JSX.Element {
  const { t, dir } = useTranslation();

  const title =
    reviewFilter === 'awaiting_approval'
      ? t('admin.orders.empty.awaitingApproval.title' as never)
      : filter === null
        ? t('admin.orders.empty.all.title')
        : t(`admin.orders.empty.${filter}` as `admin.orders.empty.${OrderStatus}`);

  const subtitle =
    reviewFilter === 'awaiting_approval'
      ? t('admin.orders.empty.awaitingApproval.subtitle' as never)
      : filter === null
        ? t('admin.orders.empty.all.subtitle')
        : undefined;

  return (
    <div
      dir={dir}
      data-testid="orders-empty"
      className="border-border bg-card shadow-admin-card flex flex-col items-center justify-center gap-4 rounded-lg border p-8 text-center"
    >
      {/* Subtle illustration placeholder */}
      <div className="bg-admin-surface-muted flex h-16 w-16 items-center justify-center rounded-full">
        <ShoppingCart
          className="text-muted-foreground"
          size={32}
          strokeWidth={1.75}
          aria-hidden="true"
        />
      </div>

      <div className="space-y-1">
        <h3 className="text-foreground text-base font-medium">{title}</h3>
        {subtitle && <p className="text-muted-foreground text-sm">{subtitle}</p>}
      </div>
    </div>
  );
}
